import * as React from 'react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getActiveUser } from '../../api/adminClientApi';
import { LoadingPageOverlay } from '../../designSystem/LoadingPageOverlay';
import { MessageCard } from '../../designSystem/Message';
import { Flex } from '../../designSystem/compositeComponents/FlexHelpers';
import { SingleColumnLayout } from '../../designSystem/layouts/SingleColumnLayout';
import { AmorgAdminPageProvider } from './AmorgAdminPageContext';
import { AdminTab } from './_components/AdminTab';
import * as dateMath from 'date-arithmetic';
import { VerticalBarGraph } from '../../designSystem/graphs/VerticalBarGraph';
import { rawColors } from '../../designSystem/colors/color';
import { StatCard } from '../../designSystem/StatCard';
import { PageSection } from '../../designSystem/PageSection';

export default function AmorgAdminSiteLogin (): JSX.Element 
{
    const navigate = useNavigate();

    const [loading, setLoading] = React.useState(true);
    useEffect(() =>
    {
        document.title = 'Amorgy - Overblik';
        const init = async () =>
        {
            await getActiveUser(() => navigate(`/amorgy/login`));
            setLoading(false);
        };
        init().catch(console.error);
    }, []);

    function getValue50To100(date: Date): number
    {
        const daySeed = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
        const hash = Math.abs(((daySeed / 86400000) * 9301 + 49297) % 233280);
        return 50 + (hash % 51);
    }

    const data = [6,5,4,3,2,1].map((daysAgo) => {
        const date = dateMath.add(new Date(), -daysAgo, 'day');

        const isSaturdatyOrSunday = date.getDay() === 0 || date.getDay() === 6;

        return {
            value: isSaturdatyOrSunday ? getValue50To100(date)/10 : getValue50To100(date),
            color: rawColors.green.normal,
            legendText: date.toLocaleDateString(),
        };
    });

    function monthsSinceFake() 
    {
        return dateMath.diff(new Date(2026, 0, 1), new Date(), 'month');
    }

    return (

        <AmorgAdminPageProvider>
            <LoadingPageOverlay loading={loading} />

            <SingleColumnLayout
                noDivider
                wide
                headerContainer={
                    <Flex flexDirection="column" gap={16}>
                        <AdminTab selectedTab='overview' />
                    </Flex>
                }

                contentContainer={
                    <Flex flexDirection='column' gap={16} style={{ width:'100%', maxWidth: '800px', margin: '0 auto' }}>

                        <MessageCard variant='info'>
                            Ingen nye beskeder
                        </MessageCard>

                        <Flex gap={16}>
                            <StatCard header={'Antal kunder'} value={(256 + (monthsSinceFake()*3)).toString()} />
                            <StatCard header={'Nye kunder'} value={(getValue50To100(new Date()) % 5).toString()} />
                        </Flex>
                
                        <PageSection styleVariant='default' header={{
                            title: 'Seneste aktivitet', icon:'interface_actions_view'
                        }}>
                            <VerticalBarGraph data={data} barHeightPx={100} heightMode={'total-sum'} />
                        </PageSection>

                    </Flex>
                }

            />
        </AmorgAdminPageProvider>
    );
}